import service from './../service.js';

export default {
    getSLCodes(){
        return service.get('/reference/sl');
    },
    createTransactionRequest(hash, type, uuid, key){
        return service.post('user/' + uuid + '/transaction', {
            hash: hash,
            type: type,
            key: key, 
        })
    },
}